import React, { useEffect, useState } from "react";
import { adminAxios } from "../../axiosInstance";
import { formatNumbersWithDecimal } from "../../components/formatNumbersWIthDecimal";

function TopSales({ currency }) {
  const [allSales, setAllSales] = useState([]);
  const fetchData = async () => {
    try {
      const response = await adminAxios.post("dashboard/all-sales");
      setAllSales(response?.data?.data);
    } catch (err) {
      console.log("Error fetching data", err);
    } finally {
      //   setIsLoading(false);
    }
  };

  function statusFormat(str) {
    if (!str) return str; // Handle empty string
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <tbody>
      {allSales.map((sale) => (
        <tr
          className="hover:bg-gray-100 border-b border-gray-300"
          key={sale.id}
        >
          <td className="py-2 px-4 text-center text-wrap">{sale?.orderNO}</td>
          <td className="py-2 px-4 text-center text-wrap">
            {sale?.user?.firstname} {sale?.user?.lastname}
          </td>
          <td className="py-2 px-4 text-center text-wrap">
            <div
              className={`p-1 text-white rounded-md ${
                sale.status == "COMPLETED" ? "bg-green-500" : "bg-yellow-500"
              }`}
            >
              {statusFormat(sale?.status)}
            </div>
          </td>
          <td className="py-2 px-4 text-center text-wrap">
            {currency}
            {formatNumbersWithDecimal(sale?.total_price)}
          </td>
        </tr>
      ))}
    </tbody>
  );
}

export default TopSales;
